import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { HttpHeaders } from 'core/classes/http'
import Logger from 'core/utils/Logger'
import settings from 'src/config/settings'

import { TRANSLATION_KEYS } from '../../../components/QBR/components/qbrDocumentDetails/components/steps/exportAndAttachments/translations'
import { REQUEST_GENERATE_PPTX_DOCUMENT } from '../constants'
import { IGenerateQbrPptxReportResponse } from '../models/generateQbrPptxReportResponse'
import { IPptxReportState } from '../models/state'
import { selectQbrPptxReport } from '../selectors/selectQbrPptxReportUid'

export const requestGeneratePptxDocument = createAsyncThunk<IPptxReportState, number>(
  REQUEST_GENERATE_PPTX_DOCUMENT,
  async (documentId, { getState }) => {
    const endpoint = `/api/v0/qbrExport/generate?entryId=${documentId}`
    const url = `${settings.httpsServices.partner360}${endpoint}`

    const ownerId = selectAppOwnerId(getState())
    const uid = selectQbrPptxReport(getState())

    const [accessToken] = getTokens(ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `${accessToken}`)
    }

    try {
      const init: RequestInit = {
        headers: {
          Authorization: `${accessToken}`,
        },
        method: 'GET',
      }
      const response = await fetch(url, init)
      const responseData: { data: IGenerateQbrPptxReportResponse[] } = await response.json()
      const [result] = responseData.data
      if (result.Status === 'success') {
        const [pptxReportName] = result.Path.split('/').reverse()
        return {
          uid: result.UID || uid || '',
          error: null,
          isGenerating: false,
          pptxReport: pptxReportName,
        }
      }

      return {
        uid: null,
        error: TRANSLATION_KEYS.qbrExport.somethingWentWrong,
        isGenerating: false,
        pptxReport: null,
      }
    } catch (e) {
      Logger.error(e)
      return {
        uid: null,
        error: TRANSLATION_KEYS.qbrExport.somethingWentWrong,
        isGenerating: false,
        pptxReport: null,
      }
    }
  }
)
